import convertPropNames from 'src/infrastructure/caseConverter'
import http, { Response } from 'src/infrastructure/http'
import { parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import stockApi from 'src/services/StockApi'
import {
  TaxCouponCreateBatchPayload,
  ItemData,
  EntryData,
  TaxCouponCreateBatchResponse,
  TaxCouponCreateReceivementPayload,
  TaxCouponCreateReceivementResponse,
  TaxCouponValidationBarcodePayload,
  ReceivementUnitChangePayload,
  SetDirectGondola,
} from './TaxCouponTypes'

interface TaxCouponEntry extends EntryData {
  idReceivement: number,
  items: ItemData[],
}

export default {
  getProductByBarcode: async ({ barcode, idReceivement }: TaxCouponValidationBarcodePayload) => {
    const { data } = await stockApi.get(`/v2/product/barcode/${barcode}`, {
      params: {
        receivement_id: idReceivement,
      },
    })

    const defaultIdMeasureUnit = 2
    return { descProduto: data.desc_produto, idModelo: data.id_modelo, scannedIdMeasure: data.measure_unit?.id || defaultIdMeasureUnit }
  },

  getProductsByDescription: async (term: string) => {
    const { data } = await http.get(`v2/product/by-description/${term}`)
    return convertPropNames<Response<any>>(data)
  },

  sendTaxCouponEntry: async (entry: TaxCouponEntry) => {
    const convertedData = {
      tax_coupon: entry.taxCoupon,
      coupon_date: entry.couponDate,
      user_badge: entry.userBadge,
      dock: entry.dock,
      id_receivement: entry.idReceivement,
      items: entry.items.map((item) => ({
        model_id: item.idModel,
        barcode: item.barcode,
        box_quantity: item.boxQuantity ? item.boxQuantity : 0,
        id_measure_unit: item.idMeasure,
        quantity: item.quantity,
        single: item.single ? item.single : 0,
        unit_cost: item.unitCost,
        expiration_date: item.expirationDate,
        batch_id: item.idBatch,
      })),
    }

    const { data } = await http.post('v2/tax-coupon/', convertedData)

    return convertPropNames<Response<any>>(data)
  },

  createTaxCouponReceivement: async (entry: TaxCouponCreateReceivementPayload) => {
    const convertedData = {
      id_fc: entry.idFc,
      user_badge: entry.userBadge,
    }

    const { data } = await http.post('v2/tax-coupon/receivement', convertedData)

    return convertPropNames<Response<TaxCouponCreateReceivementResponse>>(data)
  },

  createTaxCouponBatch: async (entry: TaxCouponCreateBatchPayload) => {
    const convertedData = {
      id_model: entry.idModel,
      barcode: entry.barcode,
      box_quantity: entry.boxQuantity,
      id_measure_unit: entry.idMeasure,
      quantity: entry.quantity,
      single: entry.single,
      unit_cost: entry.unitCost,
      expiration_date: entry.expirationDate,
      id_receivement: entry.idReceivement,
      dock: entry.dock,
    }

    const { data } = await http.post('v2/tax-coupon/batch', convertedData)

    return convertPropNames<Response<TaxCouponCreateBatchResponse>>(data)
  },

  deleteTaxCouponBatch: async (entry: number) => {
    const convertedData = {
      data: { id_batch: entry },
    }

    const { data } = await http.delete('v2/tax-coupon/batch', convertedData)

    return parseGoodResponse<any>(data)
  },

  getDirectGondola: async (idReceivement: number) => {
    const convertData = {
      id_receivement: idReceivement,
    }
    const data = await http.post('v2/tax-coupon/direct-gondola', convertData)

    return parseGoodResponse<SetDirectGondola>(data.data)
  },

  receivementUnitChange: async (payload: ReceivementUnitChangePayload) => {
    await http.get('v2/tax-coupon/supervisor', {
      headers: { 'user-barcode': payload.badgeSupervisor },
    })
    return parseGoodResponse<never>()
  },

}
